module.exports = __webpack_public_path__ + "img/icon-ocorrencia-lja.a146e235.svg";